import React, {Component, createRef} from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {getWindow} from 'ssr-window';

const window = getWindow();

export default class StripePaymentRequestButton extends Component {
    static propTypes = {
        className: PropTypes.string,
        paymentRequest: PropTypes.object.isRequired,
        currencyType: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        promoCode: PropTypes.object,
        priceBreakdownItems: PropTypes.array,
        validateReservationInfo: PropTypes.func.isRequired,
    };
    _buttonRef = createRef();
    _prButton = null;

    componentDidMount() {
        const {paymentRequest, validateReservationInfo} = this.props;

        this._prButton = window.StripeElements.create('paymentRequestButton', {
            paymentRequest,
        });
        this._prButton.on('click', async evt => {
            const {reservation} = await validateReservationInfo();

            if (!reservation) {
                return evt.preventDefault();
            }

            paymentRequest.update(this._getCurrentPaymentState());
        });
        this._prButton.mount(this._buttonRef.current);
    }

    componentWillUnmount() {
        if (this._prButton) {
            this._prButton.unmount();
            this._prButton.destroy();
            this._prButton = null;
        }
    }

    _getCurrentPaymentState() {
        const {
            currencyType,
            price,
            promoCode,
            priceBreakdownItems,
        } = this.props;
        const displayItems = [];

        if (priceBreakdownItems) {
            displayItems.push(
                ...priceBreakdownItems.map(
                    ({price: amount, short_description: label}) => {
                        return {
                            amount,
                            label,
                        };
                    }
                )
            );
        }

        if (Boolean(promoCode) && !isNaN(promoCode.discountAmount)) {
            displayItems.push({
                amount: -(promoCode.discountAmount * 100),
                label: `Promo ${
                    promoCode.codeType === 'credit' ? 'Credit' : 'Code'
                } Applied`,
            });
        }

        return {
            currency: currencyType.toLowerCase(),
            total: {
                label: 'Total',
                amount: price,
                pending: false,
            },
            ...(displayItems.length && {displayItems}),
        };
    }

    render() {
        const classes = cn('StripePaymentRequestButton', this.props.className);

        return <div ref={this._buttonRef} className={classes} />;
    }
}
